<template>
  <v-container class="pt-0" style="margin-bottom: 30px">
    <v-row>
      <v-col class="mx-0 px-0 pt-0">
        <header-text-bg :site="site" :text="title" />
      </v-col>
    </v-row>

    <v-row
      class="mx-2"
      style="display: flex; gap: 10px; margin-top: -30px; margin-bottom: 10px"
      v-if="showTab"
    >
      <v-btn
        v-for="tabItem in tabs"
        :key="tabItem.value"
        elevation="5"
        class="rounded-lg"
        @click="changeType(tabItem.value)"
        :style="{
          flex: 1,
          backgroundColor: type === tabItem.value ? site.color : 'white',
          color: type === tabItem.value ? 'white' : 'black',
          textTransform: 'none',
          fontWeight: 500,
          justifyContent: 'center',
        }"
      >
        {{ $t(tabItem.label) }}
      </v-btn>
    </v-row>

    <!-- Point ทั้งหมด -->
    <v-row
      v-if="type === 'all'"
      class="mt-2"
      :style="{ marginTop: showTab ? '0px' : '10px' }"
    >
      <template v-if="pointList.length">
        <v-col
          v-for="(item, index) in pointList"
          :key="`all-${item.point_type_name}-${index}`"
          cols="12"
          class="py-1"
        >
          <template v-if="canExpand(item)">
            <MyPointCard
              variant="expand-summary"
              :item="item"
              :expanded="expandedIds.includes(item.point_type_id)"
              @toggle="toggleExpand(item)"
            />

            <div
              class="point-expand-grid"
              :class="{
                'point-expand-grid--open': expandedIds.includes(
                  item.point_type_id
                ),
              }"
              :aria-hidden="!expandedIds.includes(item.point_type_id)"
            >
              <div class="point-expand-grid__inner">
                <div class="point-expand-grid__content">
                  <MyPointCard
                    v-for="(history, historyIndex) in processHistory(item)"
                    :key="`all-${index}-${historyIndex}`"
                    variant="breakdown"
                    :item="item"
                    :history="history"
                    :accent-color="site.color"
                    :chip-styles="expireChipStyles(history.point_expire_date)"
                  />
                </div>
              </div>
            </div>
          </template>

          <MyPointCard
            v-else
            variant="flat"
            :item="item"
            :expire-date="getSingleExpireDate(item)"
            :chip-styles="expireChipStyles(getSingleExpireDate(item))"
          />
        </v-col>
      </template>
      <v-col v-else-if="!isLoading" cols="12" class="text-center py-8">
        <v-img
          class="mx-auto empty"
          :src="require('@/assets/images/out-of-stock.png')"
          max-width="150px"
        />
        <p class="mt-2">{{ $t("errDataNotFound") }}</p>
      </v-col>
    </v-row>

    <!-- Point กำลังจะหมดอายุ -->
    <v-row v-else-if="type === 'expiring'" class="mt-2">
      <template v-if="displayListExpiring.length">
        <v-col
          v-for="(item, index) in displayListExpiring"
          :key="`exp-${item.point_type_name}-${index}-${item.expire_date}`"
          cols="12"
          class="py-1"
        >
          <MyPointCard
            variant="flat"
            :item="item"
            :expire-date="getSingleExpireDate(item)"
            :chip-styles="expireChipStyles(getSingleExpireDate(item))"
          />
        </v-col>
      </template>
      <v-col v-else-if="!isLoading" cols="12" class="text-center py-8">
        <v-img
          class="mx-auto empty"
          :src="require('@/assets/images/out-of-stock.png')"
          max-width="150px"
        />
        <p class="mt-2">{{ $t("errDataNotFound") }}</p>
      </v-col>
    </v-row>

    <!-- แลกเปลี่ยน Point -->
    <v-row v-else-if="type === 'redeemable'" class="mt-2"> </v-row>
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import moment from "moment";
import HeaderTextBg from "@/components/headerTextBg.vue";
import MyPointCard from "./components/MyPointCard.vue";

export default {
  name: "my-point",
  inject: ["isAppLoading"],
  components: {
    HeaderTextBg,
    MyPointCard,
  },
  data() {
    return {
      title: "My Point",
      type: "all",
      tabs: [
        { label: "myPointAll", value: "all", show: true },
        { label: "myPointExpire", value: "expiring", show: true },
        // { label: "myPointExchange", value: "redeemable" },
      ],
      pointList: [],
      pointTypeList: [],
      expandedIds: [],
      isLoading: false,
      showTab: true,
      viewMode: "self",
    };
  },
  created() {
    this.title = "My Point";
    const query = this.$route.query;
    if (query.type) {
      this.type = query.type;
    }
    if (query.mode == "group") {
      this.viewMode = query.mode;
      this.title = "My Point (Team)";
    }

    if (this.site.is_use_expire_coin == "N") {
      this.showTab = false;
    }

    this.getListPointType();
  },
  methods: {
    async getListPointType() {
      this.isLoading = true;
      this.isAppLoading(true);
      try {
        const response = await Axios.get("/point/getListPointRegistry", {
          params: {
            type: this.viewMode,
          },
        });
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          this.pointList = dataResponse.data;
          this.expandedIds = [];
        } else {
          this.pointList = [];
        }
      } catch (err) {
        this.pointList = [];
      } finally {
        this.isLoading = false;
        this.isAppLoading(false);
      }
    },

    changeType(newType) {
      if (this.type === newType) return;
      this.type = newType;
    },
    processHistory(item) {
      const histories = item.separate_point_history || [];

      // รวม point ทั้งหมดเป็น entry เดียว ไม่แสดงวันหมดอายุ
      if (this.site.is_use_expire_coin !== "Y") {
        const total = histories.reduce(
          (sum, h) => sum + Number(h.point || 0),
          0
        );
        return [{ point: total, point_expire_date: null }];
      }

      // ใช้ expire รวมเฉพาะกลุ่มที่ไม่มีหรือเกิน 10 ปี
      const cutoff = moment().add(10, "years");
      const withExpiry = [];
      const noExpiryGroup = [];

      histories.forEach((h) => {
        const isNoExpiry =
          !h.point_expire_date || moment(h.point_expire_date).isAfter(cutoff);
        if (isNoExpiry) noExpiryGroup.push(h);
        else withExpiry.push(h);
      });

      if (noExpiryGroup.length > 0) {
        const totalPoint = noExpiryGroup.reduce(
          (sum, h) => sum + Number(h.point || 0),
          0
        );
        withExpiry.push({ point: totalPoint, point_expire_date: null });
      }

      return withExpiry;
    },
    canExpand(item) {
      return this.processHistory(item).length > 1;
    },
    toggleExpand(item) {
      const id = item.point_type_id;
      const i = this.expandedIds.indexOf(id);
      if (i === -1) this.expandedIds.push(id);
      else this.expandedIds.splice(i, 1);
    },
    getSingleExpireDate(item) {
      const history = this.processHistory(item);
      if (history.length === 1) {
        return history[0].point_expire_date || null;
      }
      return item.expire_date || null;
    },

    getExpireChipColorForDate(dateValue) {
      const palette = [
        "#D9F6A5",
        "#FFE0B2",
        "#BBDEFB",
        "#E1BEE7",
        "#FFCDD2",
        "#B2DFDB",
        "#FFF9C4",
      ];
      const len = palette.length;
      if (!dateValue) {
        return palette[0];
      }
      const m = moment(dateValue);
      const key = m.isValid() ? m.format("YYYY-MM-DD") : String(dateValue);
      let idx = this.expireDatePaletteIndexMap[key];
      return palette[idx % len];
    },

    expireChipStyles(dateValue) {
      return {
        backgroundColor: this.getExpireChipColorForDate(dateValue),
        color: "rgba(0, 0, 0, 0.87)",
      };
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),

    expireDatePaletteIndexMap() {
      const paletteLen = 7;
      const set = new Set();
      const collect = (d) => {
        if (d === null || d === undefined || d === "") return;
        const m = moment(d);
        if (!m.isValid()) return;
        set.add(m.format("YYYY-MM-DD"));
      };
      (this.pointList || []).forEach((item) => {
        collect(item.expire_date);
        (item.separate_point_history || []).forEach((h) =>
          collect(h.point_expire_date)
        );
      });
      const sorted = [...set].sort();
      const map = Object.create(null);
      sorted.forEach((k, i) => {
        map[k] = i % paletteLen;
      });
      return map;
    },

    displayListExpiring() {
      const filtered = [...this.pointList];
      const list = [];
      filtered.forEach((item) => {
        this.processHistory(item).forEach((history) => {
          if (!history.point_expire_date) {
            return;
          }
          list.push({
            ...item,
            point: Number(history.point || 0),
            expire_date: history.point_expire_date,
          });
        });
      });
      list.sort((a, b) => {
        return moment(a.expire_date).diff(moment(b.expire_date));
      });

      return list;
    },
  },

  filters: {
    commaPoint(value) {
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return "0";
    },
    formatDate(value) {
      if (!value) return "-";
      return moment(value).format("DD MMM YYYY");
    },
  },
};
</script>

<style scoped>
.point-expand-grid {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.62s cubic-bezier(0.22, 1, 0.36, 1);
}

.point-expand-grid--open {
  grid-template-rows: 1fr;
}

.point-expand-grid__inner {
  min-height: 0;
  overflow: hidden;
}

.point-expand-grid__content {
  opacity: 0;
  transform: translateY(-6px);
  transition: opacity 0.48s cubic-bezier(0.22, 1, 0.36, 1),
    transform 0.52s cubic-bezier(0.22, 1, 0.36, 1);
}

.point-expand-grid--open .point-expand-grid__content {
  opacity: 1;
  transform: translateY(0);
}

@media (prefers-reduced-motion: reduce) {
  .point-expand-grid {
    transition-duration: 0.01ms;
  }

  .point-expand-grid__content {
    transition-duration: 0.01ms;
    transition-delay: 0ms !important;
    transform: none;
  }
}
</style>
